<div class="container">
    <img src="{{lesson?.alt}}" alt="lesson image"/>
    <p class="title">{{lesson?.add}}</p>
</div>